exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".index{width:100%}.menu{float:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-c9883784!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/Content.vue
// module id = 615
// module chunks = 2